<!-- 用户管理 -->
<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__role">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item label="姓名">
          <el-input type="text" clearable v-model="dataForm.realName" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input type="text" clearable v-model="dataForm.mobile" placeholder="手机号码"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="dataForm.status" placeholder="请选择" clearable>
            <el-option label="启用" :value="1"> </el-option>
            <el-option label="禁用" :value="0"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t("query") }}</el-button>
          <el-button @click="cleanItem">清除</el-button>
        </el-form-item>
        <el-form-item> </el-form-item>
      </el-form>
      <div>
        <el-button v-if="$hasPermission('sys:role:save')" type="primary" @click="addOrUpdateHandle()">新增</el-button>
      </div>
      <el-table v-loading="dataListLoading" :data="dataList" row-key="id" :tree-props="{ children: 'children' }" border
        @selection-change="dataListSelectionChangeHandle" @sort-change="dataListSortChangeHandle" style="width: 100%">
        <el-table-column prop="id" label="用户ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="realName" label="用户姓名" align="center" header-align="center"></el-table-column>
        <el-table-column prop="type" label="用户类型" align="center" header-align="center"><template slot-scope="scope">
            <span v-if="scope.row.type == 1">民宿老板</span>
            <span v-if="scope.row.type == 2">出租老板</span>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="headUrl" label="微信头像" header-align="center" align="center">
          <template slot-scope="scope">
            <el-image v-if="scope.row.headUrl" style="height: 100px; width: 100px; border-radius: 100pxp"
              :src="scope.row.headUrl"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="nickName" label="微信昵称" header-align="center" align="center"></el-table-column>

        <el-table-column prop="status" label="状态" header-align="center" align="center">
          <template slot-scope="scope">
            <div>
              <el-switch class="switch" :value="scope.row.status == 1 ? true : false" active-text="启用" inactive-text="冻结"
                disabled>
              </el-switch>
            </div>
          </template>
        </el-table-column>

        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="260">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">编辑</el-button>
            <!-- <el-button
              type="text"
              size="small"
              @click="passwordModification(scope.row)"
              >密码修改</el-button
            > -->
            <el-button v-if="scope.row.type == 1" type="text" size="small"
              @click="relevanceRow(scope.row)">关联民宿</el-button>
            <el-button type="text" size="small" @click="deleteHandle(scope.row.id)">Delete</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="page" :page-sizes="[10, 20, 50, 100]" :page-size="limit" :total="total"
        layout="total, sizes, prev, pager, next, jumper" @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add>
      <!-- 修改密码 -->
      <password v-if="passwordVisible" ref="passwordVisible" @refreshDataList="getDataList"></password>
      <!-- 关联民宿 -->
      <relevance v-if="relevanceVisible" ref="relevanceVisible" @refreshDataList="getDataList"></relevance>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
import password from "./password";
import relevance from "./relevance";
import add from "./add";
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/sys/user/page",
        getDataListIsPage: true,
        deleteURL: "/sys/user",
        deleteIsBatch: true,
        exportURL: "/sys/user/export",
      },
      dataForm: {
        name: "",
        type: "1,2",
      },
      options: [],
      passwordVisible: false,
      relevanceVisible: false,
    };
  },
  components: {
    add,
    password,
    relevance,
  },
  created() { },
  methods: {
    passwordModification(item) {
      this.passwordVisible = true;
      this.$nextTick(() => {
        this.$refs.passwordVisible.dataForm = item;
        this.$refs.passwordVisible.init();
      });
    },
    relevanceRow(item) {
      this.relevanceVisible = true;
      this.$nextTick(() => {
        this.$refs.relevanceVisible.dataForm = item;
        this.$refs.relevanceVisible.init();
      });
    },
    cleanItem() {
      this.dataForm = {
        status: "",
        mobile: "",
        realName: "",
      };
    },
  },
};
</script>
<style>
/* switch按钮样式 */
.switch .el-switch__label {
  position: absolute;
  display: none;
  color: #fff !important;
}

/*打开时文字位置设置*/
.switch .el-switch__label--right {
  z-index: 1;
}

/* 调整打开时文字的显示位子 */
.switch .el-switch__label--right span {
  margin-right: 9px;
}

/*关闭时文字位置设置*/
.switch .el-switch__label--left {
  z-index: 1;
}

/* 调整关闭时文字的显示位子 */
.switch .el-switch__label--left span {
  margin-left: 9px;
}

/*显示文字*/
.switch .el-switch__label.is-active {
  display: block;
}

/* 调整按钮的宽度 */
.switch.el-switch .el-switch__core,
.el-switch .el-switch__label {
  width: 60px !important;
  margin: 0;
}
</style>
